/**
 * @file The root reducer, combines all reducers.
 */

import { combineReducers } from 'redux';

import authReducer from './auth-reducer';
import albumUploadsReducer from './album-uploads-reducer';
import photoUploadsReducer from './photo-uploads-reducer';
import purchaseAlbumReducer from './purchase-album-reducer';
import purchaseAlbumPhotosReducer from './purchase-album-photos-reducer';
import discoverAlbumFolderReducer from './discover-album-folder-reducer';
import identityCreateReducer from './identity-create-reducer';
import identityUpdateReducer from './identity-update-reducer';
import modalReducer from './modal-reducer';
import photoGroupToolbarReducer from './photo-group-toolbar-reducer';
import webGalleryCartReducer from '../apps/web-gallery/redux/cart/web-gallery-cart-reducer';
import flushQueueReducer from '../apps/xcomm/redux/reducers/flush-queue-reducer';
import matchQueueReducer from '../apps/xcomm/redux/reducers/match-queue-reducer';
import albumFolderUploadsReducer from './album-folder-uploads-reducer';
import albumFolderPhotosReducer from './album-folder-photos-reducer';
import entitledPhotosIdentityFilterReducer from './entitled-photos-identity-filter.reducer';
import { AUTH_LOGOUT_SUCCESS } from '../actions/auth-actions';
import identityTagSelectionReducer from './identity-tag-selection-reducer';
import myFacesFilterReducer from './my-faces-filter-reducer';
import ppdPurchaseReducer from './ppd-purchase-reducer';
import albumFolderTagSearchReducer from './album-folder-tag-search-reducer';
import albumFolderFilenameSearchReducer from './album-folder-filename-search';
import transactionFilterReducer from './transaction-filter-reducer';
import highlightsReducer from './highlights-reducer';
import albumTransactionsFilterReducer from './album-transactions-filter-reducer';
import albumPurchasedCustomPrintsReducer from './album-purchased-custom-prints-reducer';
import pubMatchingReducer from '../apps/xcomm/redux/reducers/pub-matching-reducer';
import selfieStationReducer from '../apps/selfie-station/redux/reducers/selfie-station-reducer';
import numRecReducer from '../apps/xcomm/redux/reducers/num-rec-reducer';
import manualMatchReducer from '../apps/xcomm/redux/reducers/manual-match-reducer';
import consumerReducer from '../apps/temp/redux';
import proReducer from '../apps/pro/redux';
import webGalleryReducer from '../apps/web-gallery/redux';
import adminReducer from '../apps/admin/redux';
import checkoutReducer from '../services/checkout/redux/checkoutReducer';
import plicBooksReducer from '../services/plic-books/plic-books-reducer';
import toastReducer from './toast-reducer';
import matchedPhotosReducer from './matched-photos-reducer';
import albumFolderShutterbugFilterReducer from '../apps/pro/views/AlbumFolder/AlbumFolders/AlbumFoldersShutterbugHome/redux/albumFolderShutterbugFilterReducer';

const appReducer = () =>
  combineReducers({
    auth: authReducer,
    albumUploads: albumUploadsReducer,
    photoUploads: photoUploadsReducer,
    purchaseAlbum: purchaseAlbumReducer,
    purchaseAlbumPhotos: purchaseAlbumPhotosReducer,
    discoverAlbumFolder: discoverAlbumFolderReducer,
    identityCreate: identityCreateReducer,
    identityUpdate: identityUpdateReducer,
    modal: modalReducer,
    photoGroupToolbar: photoGroupToolbarReducer,
    flushQueue: flushQueueReducer,
    webGalleryCart: webGalleryCartReducer,
    matchQueue: matchQueueReducer,
    pubMatchingQueue: pubMatchingReducer,
    numRecQueue: numRecReducer,
    manualMatchQueue: manualMatchReducer,
    albumFolderUploads: albumFolderUploadsReducer,
    albumFolderPhotos: albumFolderPhotosReducer,
    entitledPhotosIdentityFilter: entitledPhotosIdentityFilterReducer,
    identityTagSelection: identityTagSelectionReducer,
    myFacesFilter: myFacesFilterReducer,
    ppdPurchase: ppdPurchaseReducer,
    albumFolderTagSearch: albumFolderTagSearchReducer,
    albumFolderFilenameSearch: albumFolderFilenameSearchReducer,
    transactionFilter: transactionFilterReducer,
    albumTransactionsFilter: albumTransactionsFilterReducer,
    highlights: highlightsReducer,
    albumPurchasedCustomPrints: albumPurchasedCustomPrintsReducer,
    selfieStation: selfieStationReducer,
    consumer: consumerReducer,
    pro: proReducer,
    galleries: webGalleryReducer,
    admin: adminReducer,
    checkout: checkoutReducer,
    plicBooks: plicBooksReducer,
    toast: toastReducer,
    albumFolderShutterbugFilter: albumFolderShutterbugFilterReducer,
    matchedPhotos: matchedPhotosReducer,
  });

const createRootReducer = () => (state, action) => {
  // Reset redux store on logout
  // This is not ever fired currently because we're going
  // the location.reload method but might be useful in the future.
  if (action.type === AUTH_LOGOUT_SUCCESS) {
    state = undefined; // eslint-disable-line no-param-reassign
  }

  return appReducer()(state, action);
};

export default createRootReducer;
